import { Controller } from '@hotwired/stimulus'

const SHADOWS = {
  x: {
    start: 'inset 20px 0 20px -20px',
    end: 'inset -20px 0 20px -20px'
  },
  y: {
    start: 'inset 0 20px 20px -20px',
    end: 'inset 0 -20px 20px -20px'
  }
}

export default class extends Controller {
  static targets = ['content', 'overlay']
  static values = { axes: String, mask: Boolean }

  connect() {
    this.updateShading()
  }

  updateShading() {
    this.maskValue ? this.#updateMask() : this.#updateShadows()
  }

  #updateMask() {
    const { scrollLeft, clientWidth, scrollWidth } = this.contentTarget

    const distances = {
      '--mask-distance-l': scrollLeft,
      '--mask-distance-r': scrollWidth - clientWidth - scrollLeft
    }

    for (const [property, remaining] of Object.entries(distances)) {
      this.element.style.setProperty(
        property,
        `min(var(--mask-distance), ${Math.max(remaining, 0)}px)`
      )
    }
  }

  #updateShadows() {
    const color = this.#shadowColor
    const shadows = []

    for (const axis of this.#activeAxes) {
      if (this.#hasOverflow(axis, 'start')) {
        shadows.push(`${SHADOWS[axis].start} ${color}`)
      }

      if (this.#hasOverflow(axis, 'end')) {
        shadows.push(`${SHADOWS[axis].end} ${color}`)
      }
    }

    this.overlayTarget.style.boxShadow = shadows.join(', ')
  }

  get #shadowColor() {
    return document.documentElement.classList.contains('dark')
      ? 'rgba(0,0,0,0.75)'
      : 'rgba(50,50,93,0.4)'
  }

  get #activeAxes() {
    if (this.axesValue === 'both') return ['x', 'y']
    return [this.axesValue].filter(a => a === 'x' || a === 'y')
  }

  #hasOverflow(axis, boundary) {
    const {
      scrollLeft,
      scrollTop,
      clientWidth,
      clientHeight,
      scrollWidth,
      scrollHeight
    } = this.contentTarget

    if (axis === 'x') {
      return boundary === 'start'
        ? scrollLeft > 0
        : scrollLeft + clientWidth < scrollWidth
    } else {
      return boundary === 'start'
        ? scrollTop > 0
        : scrollTop + clientHeight < scrollHeight
    }
  }
}
